import TreeMultiSelector, { type TreeNode } from 'components/TreeMultiSelector/TreeMultiSelector';
import {type FC} from 'react';
import { type NestedYear } from 'types';

export const getPeriodOptions = (years: NestedYear[]): TreeNode[] => {
  const sortedYears = [...years].sort((a, b) => Number(b.year) - Number(a.year));

  return sortedYears.map((year) => {
    const sortedQuarters = [...year.quarters].sort((a, b) => {
      const quarterA = Number.parseInt(a.slice(1), 10);
      const quarterB = Number.parseInt(b.slice(1), 10);
      return quarterB - quarterA;
    });

    return {
      children: sortedQuarters.map((quarter) => ({
        id: `${year.year}/${quarter}`,
        name: `${quarter} ${year.year}`,
      })),
      id: year.year.toString(),
      name: year.year.toString(),
    };
  });
};

const formatPeriodsToYearsAndQuarters = (periods: string[]): NestedYear[] => {
  const result: NestedYear[] = [];

  for (const period of periods) {
    const [yearStr, quarterStr] = period.split('/');

    const existingYear = result.find((y) => y.year === Number(yearStr));
    if (existingYear) {
      if (!existingYear.quarters.includes(quarterStr)) {
        existingYear.quarters.push(quarterStr);
      }
    } else {
      result.push({
        quarters: [quarterStr],
        year: Number(yearStr),
      });
    }
  }

  return result;
};

type YearSelectorProps = {
  availablePeriods: NestedYear[],
  selectedPeriods: NestedYear[],
  setSelectedPeriods: React.Dispatch<React.SetStateAction<NestedYear[]>>,
};

const YearSelector: FC<YearSelectorProps> =
({ availablePeriods,
  selectedPeriods, setSelectedPeriods}: YearSelectorProps) => {
  const checkYear = (years: string[], quarters: string[]) => {
    const yearsAndQuarters = formatPeriodsToYearsAndQuarters(quarters);
    setSelectedPeriods(yearsAndQuarters);
  };

  return (
    <div className='flex w-full flex-col'>
      <p className='m-0 text-font-3 font-medium'>Period</p>
      <TreeMultiSelector
        dataSelectionValue='period-filter-multiselector'
        description='Select periods'
        disabled={!getPeriodOptions(availablePeriods).length}
        inputStyle='bg-white-999 relative flex items-center justify-center w-full h-[2.75rem] py-0 rounded-main border-black-300 border'
        mobile={false}
        onCheck={checkYear}
        optionsContainerStyle='!top-[2.75rem]'
        placeholder='All periods'
        selectedData={getPeriodOptions(selectedPeriods)}
        treeData={getPeriodOptions(availablePeriods)}
      />
    </div>

  );
};

export { YearSelector };
